<section class="shopping-checkout-wrap mt-4">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <!--== Start Billing Accordion ==-->
        <div class="checkout-billing-details-wrap">
          <h2 class="title">Delievery Information</h2>
          <div class="billing-form-wrap">
            <form [formGroup]="addressForm" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="f_name">
                      First name
                      <abbr class="required" title="required">*</abbr>
                    </label>
                    <input
                      id="f_name"
                      type="text"
                      class="form-control"
                      formControlName="firstName"
                    />
                    <div
                      *ngIf="submitted && addressForm.get('firstName')?.invalid"
                      class="text-danger"
                    >
                      First name is required.
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="l_name">
                      Last name <abbr class="required" title="required">*</abbr>
                    </label>
                    <input
                      id="l_name"
                      type="text"
                      class="form-control"
                      formControlName="lastName"
                    />
                    <div
                      *ngIf="submitted && addressForm.get('lastName')?.invalid"
                      class="text-danger"
                    >
                      Last name is required.
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="street-address">
                      Street address
                      <abbr class="required" title="required">*</abbr>
                    </label>
                    <input
                      id="street-address"
                      type="text"
                      class="form-control"
                      formControlName="streetAddress1"
                      placeholder="House number and street name"
                    />
                    <div
                      *ngIf="
                        submitted && addressForm.get('streetAddress1')?.invalid
                      "
                      class="text-danger"
                    >
                      Street address is required.
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="street-address2" class="visually-hidden">
                      Street address 2
                      <abbr class="required" title="required">*</abbr>
                    </label>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="pz-code">Postcode / ZIP (optional)</label>
                    <input
                      id="pz-code"
                      type="text"
                      class="form-control"
                      formControlName="postcode"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="phone">Phone</label>
                    <input
                      id="phone"
                      type="text"
                      class="form-control"
                      formControlName="phone"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group" data-margin-bottom="30">
                    <label for="email">
                      Email address
                      <abbr class="required" title="required">*</abbr>
                    </label>
                    <input
                      id="email"
                      type="text"
                      class="form-control"
                      formControlName="email"
                    />
                    <div
                      *ngIf="submitted && addressForm.get('email')?.invalid"
                      class="text-danger"
                    >
                      A valid email is required.
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <button
              style="padding: 12px"
              (click)="onSubmit()"
              type="button"
              class="btn-theme"
            >
              Place order
            </button>
          </div>
        </div>
        <!--== End Billing Accordion ==-->
      </div>
      <div class="col-lg-6">
        <!--== Start Order Details Accordion ==-->
        <div class="checkout-order-details-wrap">
          <h2 class="title mb-25">Cart Totals</h2>
          <div class="order-details-table-wrap table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="product-name">Product</th>
                  <th class="product-total">Total</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr *ngFor="let item of cartItems" class="cart-item">
                  <td class="product-name">
                    {{ item.name }}
                    <span class="product-quantity">× {{ item.quantity }} </span>
                  </td>
                  <td class="product-total">
                    ${{ item.price * item.quantity }}
                  </td>
                </tr>
              </tbody>
              <tfoot class="table-foot">
                <tr class="cart-subtotal">
                  <th>Subtotal</th>
                  <td>₹ {{ totalPrice }}</td>
                </tr>

                <tr class="cart-subtotal">
                  <th>Delievery Fees</th>
                  <td>₹ 50</td>
                </tr>

                <tr class="order-total">
                  <th>Total</th>
                  <td>₹ {{ totalPrice + 50 }}</td>
                </tr>
              </tfoot>
            </table>
          </div>

          <h2 class="title mb-25">Payment Methods</h2>

          <div class="order-details-table-wrap table-responsive">
            <div class="shop-payment-method">
              <ul class="shipping-list">
                <li class="radio">
                  <input type="radio" name="shipping" id="radio2" />
                  <label for="radio2"
                    ><span></span> &nbsp;&nbsp; COD (Cash on delievery)</label
                  >
                </li>
                <li class="radio">
                  <input type="radio" name="shipping" id="radio3" />
                  <label for="radio3"
                    ><span></span> &nbsp;&nbsp; Stripe (Credit/Debit)</label
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--== End Order Details Accordion ==-->
      </div>
    </div>
  </div>
</section>
